<div class="overflow-scroll p-3 max-h-[80vh] hide-scrollbars max-w-[36.5rem]">
  <div class="flex justify-between items-stretch">
    <div class="space-y-4 pt-3">
      <div class="flex flex-wrap justify-start">
        <p class="font-semibold leading-none text-h2 text-tilled-primary">
          {{ dialogTitle }}
        </p>
      </div>
      <div class="flex flex-col leading-snug space-y-4">
        <span class="">
          {{ dialogSubtitle }}
        </span>
        <span
          *ngIf="currentStep === 1"
          class="italic font-semibold text-sm text-warn"
        >
          Requesting information updates the application status to 'Action
          Required' and preserves all existing inputs.
        </span>
      </div>
    </div>
    <div class="mat-icon-container">
      <mat-icon
        data-test-id="form-card-exit-button"
        style="cursor: pointer"
        (click)="matDialogRef.close()"
        svgIcon="mat_outline:close"
        class="text-tilled-primary"
      ></mat-icon>
    </div>
  </div>

  <div class="my-3" [ngClass]="{ hidden: (isLoading$ | async) }">
    <mat-stepper #stepper cdk-scrollable labelPosition="bottom">
      <!-- Document request type selections step -->
      <mat-step label="First Step" color="primary" class="overflow-y-auto">
        <div class="flex flex-row items-center py-2">
          <mat-divider class="w-full"></mat-divider>
          <p
            class="self-center whitespace-nowrap px-2 font-[600] not-italic leading-normal tracking-normal text-tilled-primary"
          >
            Written Prompts
          </p>
          <mat-divider class="w-full"></mat-divider>
        </div>
        <form class="px-4" [formGroup]="writtenForm">
          <div
            *ngFor="let type of writtenSubtypes"
            [ngClass]="{
              'flex flex-row flex-nowrap justify-start border-y my-1 gap-4 flex-1 overflow-clip':
                (type.toString() === 'admin_return' &&
                  showAdminReturnsAmount) ||
                (type.toString() === 'insufficient_funds_return' &&
                  showInsufficientReturnsAmount) ||
                (type.toString() === 'unauthorized_return' &&
                  showUnauthorizedReturnsAmount)
            }"
          >
            <div 
              [ngClass]="{
                'w-50 pr-4 border-r border-gray-300':
                  (type.toString() === 'admin_return' &&
                    showAdminReturnsAmount) ||
                  (type.toString() === 'insufficient_funds_return' &&
                    showInsufficientReturnsAmount) ||
                  (type.toString() === 'unauthorized_return' &&
                    showUnauthorizedReturnsAmount)
              }"
            >
              <mat-checkbox
                class="py-1"
                [ngClass]="{
                  'items-center flex mb-6':
                    (type.toString() === 'admin_return' &&
                      showAdminReturnsAmount) ||
                    (type.toString() === 'insufficient_funds_return' &&
                      showInsufficientReturnsAmount) ||
                    (type.toString() === 'unauthorized_return' &&
                      showUnauthorizedReturnsAmount)
                }"
                [formControlName]="type.toString()"
                (change)="onCheckboxChange($event, type.toString())"
              >
                <span class="text-base tracking-normal text-tilled-primary">
                  {{ mapSubtypeToTitle(type) }}
                </span>
              </mat-checkbox>
            </div>
            <!-- Admin Returns Amount -->
            <div 
              class="flex-1"
              *ngIf="
                type.toString() === 'admin_return' && showAdminReturnsAmount
              "
            >
              <mat-form-field class="pt-2 -mb-2.5 w-full pl-5">
                <input
                  matInput
                  placeholder="How many Admin ACH returns does this merchant have?"
                  formControlName="numberOfAdminReturns"
                  type="number"
                  min="0"
                  step="1"
                />
                <mat-error
                  color="warn"
                  *ngIf="
                    writtenForm.get('numberOfAdminReturns').errors &&
                    writtenForm.get('numberOfAdminReturns').touched
                  "
                  class="pt-2 text-sm mt-0 font-normal leading-tight"
                >
                  If <b>Admin Return</b> is selected, a number of returns is
                  required.
                </mat-error>
                <mat-hint class="text-sm font-normal leading-tight pt-1">
                  This is the number of Admin ACH Returns that this merchant
                  has.
                </mat-hint>
              </mat-form-field>
            </div>

            <!-- Insufficient Funds Returns Amount -->
            <div 
              class="flex-1"
              *ngIf="
                type.toString() === 'insufficient_funds_return' &&
                showInsufficientReturnsAmount
              "
            >
              <mat-form-field class="pt-2 -mb-2.5 w-full pl-5">
                <input
                  matInput
                  placeholder="How many Insufficient ACH funds returns does this merchant have?"
                  formControlName="numberOfInsufficientFundsReturns"
                  type="number"
                  min="0"
                  step="1"
                />
                <mat-error
                  color="warn"
                  *ngIf="
                    writtenForm.get('numberOfInsufficientFundsReturns')
                      .errors &&
                    writtenForm.get('numberOfInsufficientFundsReturns').touched
                  "
                  class="pt-2 text-sm mt-0 font-normal leading-tight"
                >
                  If <b>Insufficient Funds Return</b> is selected, a number of
                  returns is required.
                </mat-error>
                <mat-hint class="text-sm font-normal leading-tight pt-1">
                  This is the number of Insufficient ACH Funds Returns that this
                  merchant has.
                </mat-hint>
              </mat-form-field>
            </div>

            <!-- Unauthorized Returns Amount -->
            <div 
              class="flex-1"
              *ngIf="
                type.toString() === 'unauthorized_return' &&
                showUnauthorizedReturnsAmount
              "
            >
              <mat-form-field class="pt-2 -mb-2.5 w-full pl-5">
                <input
                  matInput
                  placeholder="How many Unauthorized ACH returns does this merchant have?"
                  formControlName="numberOfUnauthorizedReturns"
                  type="number"
                  min="0"
                  step="1"
                />
                <mat-error
                  color="warn"
                  *ngIf="
                    writtenForm.get('numberOfUnauthorizedReturns').errors &&
                    writtenForm.get('numberOfUnauthorizedReturns').touched
                  "
                  class="pt-2 text-sm mt-0 font-normal leading-tight"
                >
                  If <b>Unauthorized Return</b> is selected, a number of returns
                  is required.
                </mat-error>
                <mat-hint class="text-sm font-normal leading-tight pt-1">
                  This is the number of Unauthorized ACH Returns that this
                  merchant has.
                </mat-hint>
              </mat-form-field>
            </div>
          </div>
        </form>
        <div class="flex flex-row items-center py-2">
          <mat-divider class="w-full"></mat-divider>
          <p
            class="self-center whitespace-nowrap px-2 font-[600] not-italic leading-normal tracking-normal text-tilled-primary"
          >
            Business Documents
          </p>
          <mat-divider class="w-full"></mat-divider>
        </div>
        <form class="px-4" [formGroup]="documentForm">
          <div
            *ngFor="let type of documentSubtypes"
            [ngClass]="{
              'flex flex-row flex-nowrap justify-start border-y my-1 gap-4 flex-1 overflow-clip':
                type.toString() === 'invoice' && showInvoiceAmount
            }"
          >
            <div 
              [ngClass]="{
                'w-80 pr-4 border-r border-gray-300':
                  type.toString() === 'invoice' && showInvoiceAmount
              }"
            >
              <mat-checkbox
                class="py-1"
                [ngClass]="{
                  'items-center flex mb-6':
                    type.toString() === 'invoice' && showInvoiceAmount
                }"
                [formControlName]="type.toString()"
                (change)="onCheckboxChange($event, type.toString())"
              >
                <span class="text-base tracking-normal text-tilled-primary">
                  {{ mapSubtypeToTitle(type) }}
                </span>
              </mat-checkbox>
            </div>
            <div 
              class="flex-1"
              *ngIf="type.toString() === 'invoice' && showInvoiceAmount"
            >
              <mat-form-field class="pt-2 -mb-2.5 w-full pl-5">
                <input
                  matInput
                  placeholder="How many invoices should the merchant provide?"
                  formControlName="numberOfInvoices"
                  type="number"
                  min="0"
                  step="1"
                />
                <mat-error
                  color="warn"
                  *ngIf="
                    documentForm.get('numberOfInvoices').errors &&
                    documentForm.get('numberOfInvoices').touched
                  "
                  class="pt-2 text-sm mt-0 font-normal leading-tight"
                >
                  If <b>Invoice</b> is selected, a number of invoices is
                  required.
                </mat-error>
                <mat-hint class="text-sm font-normal leading-tight pt-1">
                  This is the number of invoices you are requesting from the
                  merchant.
                </mat-hint>
              </mat-form-field>
            </div>
          </div>
        </form>

        <div class="flex w-full justify-end">
          <!-- Cancel button -->
          <button class="mr-4" mat-button (click)="cancelClicked()">
            Cancel
          </button>
          <!-- Open application button -->
          <button mat-flat-button color="primary" (click)="nextPage()">
            <span>Next</span>
          </button>
        </div>
      </mat-step>

      <!-- Request notes and submit step -->
      <mat-step label="Second Step" color="primary" class="overflow-y-auto">
        <ng-container *ngIf="checkedWrittenSubtypes?.length > 0">
          <div class="flex flex-row items-center py-2">
            <mat-divider class="w-full"></mat-divider>
            <p
              class="self-center whitespace-nowrap px-2 font-[600] not-italic leading-normal tracking-normal text-tilled-primary"
            >
              Written Prompts
            </p>
            <mat-divider class="w-full"></mat-divider>
          </div>
          <form
            [formGroup]="writtenRequestForm"
            *ngIf="checkedWrittenSubtypes?.length > 0"
          >
            <div *ngFor="let type of checkedWrittenSubtypes">
              <ng-container
                *ngIf="
                  !(
                    (type.toString() === 'admin_return' &&
                      numberOfAdminReturns > 1) ||
                    (type.toString() === 'insufficient_funds_return' &&
                      numberOfInsufficientFundsReturns > 1) ||
                    (type.toString() === 'unauthorized_return' &&
                      numberOfUnauthorizedReturns > 1)
                  )
                "
              >
                <ng-container
                  *ngIf="
                    type.toString() === 'admin_return' ||
                    type.toString() === 'insufficient_funds_return' ||
                    type.toString() === 'unauthorized_return'
                  "
                >
                  <div class="flex flex-row items-center py-2">
                    <mat-divider class="w-full"></mat-divider>
                    <p
                      class="self-center whitespace-nowrap px-2 text-md font-[600] not-italic leading-normal tracking-normal text-tilled-primary"
                    >
                      {{ mapSubtypeToTitle(type) }}
                    </p>
                    <mat-divider class="w-full"></mat-divider>
                  </div>
                  <span
                    class="tracking-normal text-tilled-primary self-center font-medium flex pb-1.5"
                  >
                    Payment Intent ID
                  </span>
                  <mat-form-field class="w-full">
                    <input
                      matInput
                      [formControlName]="type.toString() + '_pi'"
                      placeholder="Payment Intent Id"
                      maxLength="255"
                    />
                    <mat-hint class="text-sm font-normal leading-tight pt-1">
                      The Payment intent ID associated with the return.
                    </mat-hint>
                  </mat-form-field>
                </ng-container>
                <span
                  class="tracking-normal text-tilled-primary self-center font-medium flex pb-1.5"
                >
                  {{
                    type.toString() === 'admin_return' ||
                    type.toString() === 'insufficient_funds_return' ||
                    type.toString() === 'unauthorized_return'
                      ? type.toString() === 'admin_return'
                        ? 'Admin Return context'
                        : type.toString() === 'insufficient_funds_return'
                        ? 'Insufficient Funds Return context'
                        : 'Unauthorized Return context'
                      : mapSubtypeToTitle(type)
                  }}
                </span>
                <mat-form-field class="w-full">
                  <input
                    matInput
                    [formControlName]="type.toString()"
                    maxLength="255"
                    placeholder="Context"
                  />
                  <mat-hint
                    *ngIf="
                      type.toString() === 'admin_return' ||
                      type.toString() === 'insufficient_funds_return' ||
                      type.toString() === 'unauthorized_return'
                    "
                    class="text-sm font-normal leading-tight pt-1"
                  >
                    This is any additional context surrounding the specific
                    return request.
                  </mat-hint>
                </mat-form-field>
                <mat-divider
                  *ngIf="
                    type.toString() === 'admin_return' ||
                    type.toString() === 'insufficient_funds_return' ||
                    type.toString() === 'unauthorized_return'
                  "
                  class="w-full pb-4"
                ></mat-divider>
              </ng-container>
            </div>
            <ng-container *ngIf="numberOfAdminReturns > 1">
              <ng-container
                *ngFor="let control of adminReturnControl; let i = index"
              >
                <div
                  class="flex flex-row items-center py-2"
                  *ngIf="control.label === 'Payment Intent Id'"
                >
                  <mat-divider class="w-full"></mat-divider>
                  <p
                    class="self-center whitespace-nowrap px-2 text-md font-[600] not-italic leading-normal tracking-normal text-tilled-primary"
                  >
                    {{
                      'Admin ACH Return' +
                        (control.index === 0 ? '' : ' #' + control.index)
                    }}
                  </p>
                  <mat-divider class="w-full"></mat-divider>
                </div>
                <span
                  class="tracking-normal text-tilled-primary self-center font-medium flex pb-1.5"
                >
                  {{ control.label }}
                </span>
                <mat-form-field class="w-full">
                  <input
                    matInput
                    [formControlName]="control.control"
                    [placeholder]="
                      control.label === 'Payment Intent Id'
                        ? 'Payment Intent Id'
                        : 'Context'
                    "
                    maxLength="255"
                  />
                  <mat-hint 
                    *ngIf="control.label === 'Payment Intent Id'"
                    class="text-sm font-normal leading-tight pt-1">
                    The Payment intent ID associated with the return.
                  </mat-hint>
                  <mat-hint 
                    *ngIf="control.label !== 'Payment Intent Id'"
                    class="text-sm font-normal leading-tight pt-1">
                    This is any additional context surrounding the specific return request.
                  </mat-hint>
                </mat-form-field>
              </ng-container>
            </ng-container>
            <ng-container *ngIf="numberOfInsufficientFundsReturns > 1">
              <ng-container
                *ngFor="let control of insufficientFundsControl; let i = index"
              >
                <div
                  class="flex flex-row items-center py-2"
                  *ngIf="control.label === 'Payment Intent Id'"
                >
                  <mat-divider class="w-full"></mat-divider>
                  <p
                    class="self-center whitespace-nowrap px-2 text-md font-[600] not-italic leading-normal tracking-normal text-tilled-primary"
                  >
                    {{
                      'Insufficient Funds ACH Return' +
                        (control.index === 0 ? '' : ' #' + control.index)
                    }}
                  </p>
                  <mat-divider class="w-full"></mat-divider>
                </div>
                <span
                  class="tracking-normal text-tilled-primary self-center font-medium flex pb-1.5"
                >
                  {{ control.label }}
                </span>
                <mat-form-field class="w-full">
                  <input
                    matInput
                    [formControlName]="control.control"
                    [placeholder]="
                      control.label === 'Payment Intent Id'
                        ? 'Payment Intent Id'
                        : 'Context'
                    "
                    maxLength="255"
                  />
                  <mat-hint 
                    *ngIf="control.label === 'Payment Intent Id'"
                    class="text-sm font-normal leading-tight pt-1">
                    The Payment intent ID associated with the return.
                  </mat-hint>
                  <mat-hint 
                    *ngIf="control.label !== 'Payment Intent Id'"
                    class="text-sm font-normal leading-tight pt-1">
                    This is any additional context surrounding the specific return request.
                  </mat-hint>
                </mat-form-field>
              </ng-container>
            </ng-container>
            <ng-container *ngIf="numberOfUnauthorizedReturns > 1">
              <ng-container
                *ngFor="
                  let control of unauthorizedReturnsControl;
                  let i = index
                "
              >
                <div
                  class="flex flex-row items-center py-2"
                  *ngIf="control.label === 'Payment Intent Id'"
                >
                  <mat-divider class="w-full"></mat-divider>
                  <p
                    class="self-center whitespace-nowrap px-2 text-md font-[600] not-italic leading-normal tracking-normal text-tilled-primary"
                  >
                    {{
                      'Unauthorized ACH Return' +
                        (control.index === 0 ? '' : ' #' + control.index)
                    }}
                  </p>
                  <mat-divider class="w-full"></mat-divider>
                </div>
                <span
                  class="tracking-normal text-tilled-primary self-center font-medium flex pb-1.5"
                >
                  {{ control.label }}
                </span>
                <mat-form-field class="w-full">
                  <input
                    matInput
                    [formControlName]="control.control"
                    [placeholder]="
                      control.label === 'Payment Intent Id'
                        ? 'Payment Intent Id'
                        : 'Context'
                    "
                    maxLength="255"
                  />
                  <mat-hint 
                    *ngIf="control.label === 'Payment Intent Id'"
                    class="text-sm font-normal leading-tight pt-1">
                    The Payment intent ID associated with the return.
                  </mat-hint>
                  <mat-hint 
                    *ngIf="control.label !== 'Payment Intent Id'"
                    class="text-sm font-normal leading-tight pt-1">
                    This is any additional context surrounding the specific return request.
                  </mat-hint>
                </mat-form-field>
              </ng-container>
            </ng-container>
          </form>
        </ng-container>

        <ng-container *ngIf="checkedDocumentSubtypes?.length > 0">
          <div class="flex flex-row items-center py-2">
            <mat-divider class="w-full"></mat-divider>
            <p
              class="self-center whitespace-nowrap px-2 font-[600] not-italic leading-normal tracking-normal text-tilled-primary"
            >
              Business Documents
            </p>
            <mat-divider class="w-full"></mat-divider>
          </div>
          <form [formGroup]="documentRequestForm">
            <div *ngFor="let type of checkedDocumentSubtypes">
              <ng-container
                *ngIf="!(type.toString() === 'invoice' && numberOfInvoices > 1)"
              >
                <ng-container *ngIf="type.toString() === 'invoice'">
                  <div class="flex flex-row items-center py-2">
                    <mat-divider class="w-full"></mat-divider>
                    <p
                      class="self-center whitespace-nowrap px-2 text-md font-[600] not-italic leading-normal tracking-normal text-tilled-primary"
                    >
                      Invoice
                    </p>
                    <mat-divider class="w-full"></mat-divider>
                  </div>
                  <span
                    class="tracking-normal text-tilled-primary self-center font-medium flex pb-1.5"
                  >
                    Payment intent ID
                  </span>
                  <mat-form-field class="w-full">
                    <input
                      matInput
                      [formControlName]="type.toString() + '_pi'"
                      maxLength="255"
                      placeholder="Payment Intent Id"
                      [value]="defaultRequestNoteValue(type)"
                    />
                    <mat-hint class="text-sm font-normal leading-tight pt-1">
                      The Payment intent ID associated with the invoice.
                    </mat-hint>
                  </mat-form-field>
                </ng-container>
                <span
                  class="tracking-normal text-tilled-primary self-center font-medium flex pb-1.5"
                >
                  {{
                    type.toString() === 'invoice'
                      ? 'Invoice context'
                      : mapSubtypeToTitle(type)
                  }}
                </span>
                <mat-form-field class="w-full">
                  <input
                    matInput
                    [formControlName]="type.toString()"
                    maxLength="255"
                    placeholder="Context"
                    value="{{ defaultRequestNoteValue(type) }}"
                  />
                  <mat-hint
                    *ngIf="type.toString() === 'invoice'"
                    class="text-sm font-normal leading-tight pt-1"
                  >
                    This is any additional context surrounding the specific
                    invoice request.
                  </mat-hint>
                </mat-form-field>
                <mat-divider
                  *ngIf="type.toString() === 'invoice'"
                  class="w-full pb-4"
                ></mat-divider>
              </ng-container>
            </div>
            <ng-container *ngIf="numberOfInvoices > 1">
              <ng-container
                *ngFor="let control of invoiceControls; let i = index"
              >
                <div
                  class="flex flex-row items-center py-2"
                  *ngIf="control.label === 'Payment Intent Id'"
                >
                  <mat-divider class="w-full"></mat-divider>
                  <p
                    class="self-center whitespace-nowrap px-2 text-md font-[600] not-italic leading-normal tracking-normal text-tilled-primary"
                  >
                    {{
                      'Invoice' +
                        (control.index === 0 ? '' : ' #' + control.index)
                    }}
                  </p>
                  <mat-divider class="w-full"></mat-divider>
                </div>
                <span
                  class="tracking-normal text-tilled-primary self-center font-medium flex pb-1.5"
                >
                  {{ control.label }}
                </span>
                <mat-form-field class="w-full">
                  <input
                    matInput
                    [formControlName]="control.control"
                    [placeholder]="
                      control.label === 'Payment Intent Id'
                        ? 'Payment Intent Id'
                        : 'Context'
                    "
                    maxLength="255"
                    value="{{ defaultRequestNoteValue(type) }}"
                  />
                  <mat-hint 
                    *ngIf="control.label === 'Payment Intent Id'"
                    class="text-sm font-normal leading-tight pt-1">
                    The Payment intent ID associated with the invoice.
                  </mat-hint>
                  <mat-hint 
                    *ngIf="control.label !== 'Payment Intent Id'"
                    class="text-sm font-normal leading-tight pt-1">
                    This is any additional context surrounding the specific invoice request.
                  </mat-hint>
                </mat-form-field>
              </ng-container>
            </ng-container>
          </form>
        </ng-container>
        <div class="flex w-full justify-end">
          <!-- Cancel button -->
          <button class="mr-4" mat-button (click)="backPage()">Back</button>
          <!-- Open application button -->
          <button mat-flat-button color="primary" (click)="submitClicked()">
            <span>Submit Request</span>
          </button>
        </div>
      </mat-step>
      <mat-step label="Second Step" color="primary"> </mat-step>
    </mat-stepper>
  </div>
  <ng-container *ngIf="isLoading$ | async">
    <div>
      <mat-progress-spinner
        [diameter]="24"
        [mode]="'indeterminate'"
      ></mat-progress-spinner>
    </div>
  </ng-container>
</div>
